import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { path: '/', label: '首页' },
  { path: '/category/all', label: '漫画分类' },
  { path: '/category/all', label: '排行榜' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between h-16 px-4 md:px-6" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center">
            <i className="ri-book-open-line text-xl md:text-2xl text-primary-500"></i>
          </div>
          <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">
            韩漫大全
          </span>
        </Link>

        <ul className="hidden md:flex items-center gap-8">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    isActive
                      ? 'text-primary-600'
                      : 'text-foreground-700 hover:text-primary-500'
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <button className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-user-line mr-1"></i>
            登录
          </button>
          <button className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer">
            <i className="ri-search-line text-base"></i>
          </button>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl text-foreground-950 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <ul className="flex flex-col py-3 px-4 gap-1">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`block py-3 px-4 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
            <div className="flex items-center gap-3 pt-3 px-4 border-t border-background-200 mt-2">
              <button className="flex-1 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                登录 / 注册
              </button>
            </div>
          </ul>
        </div>
      )}
    </header>
  );
}